/* eslint-disable arrow-body-style */
import _ from 'underscore';

export const getWinStoreStyles = ({ styleOverrides }) => () => {
  return {
    winStoreWindows: _.extend({
      flexDirection: 'column',
      alignItems: 'center',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'space-between',
      top: 20,
      left: '50%',
      color: 'white',
      transform: 'translate(-50%)',
      '& .welcome': {
        marginBottom: 10,
      },
      '& .time': {
        fontSize: 40,
      },
    }, styleOverrides.winStoreWindows),
    icon: _.extend({
      display: 'inline-block',
      height: '16px',
      width: '16px',
      verticalAlign: 'text-top',
    }, styleOverrides.phoneAndAddressDecoratorIcon),
    adBadge: _.extend({
      position: 'absolute',
      top: 140,
      left: 94,
      zIndex: 1,
    }, styleOverrides.phoneAndAddressDecoratorIcon),
    getButton: _.extend({
      position: 'absolute',
      top: 187,
      left: 94,
      zIndex: 1,
    }, styleOverrides.phoneAndAddressDecoratorIcon),
  };
};
